/* globals lory */

define([
  'lory',
  '!domReady!'
],
function(loryLib) {
  'use strict';

  return function(config, element) {
    class Slider {
      constructor(slider) {
        this.config = {
          classNameFrame            : 'slider__handler',
          classNameSlideContainer   : 'slider__slides',
          classNamePrevCtrl         : 'slider__prev',
          classNameNextCtrl         : 'slider__next',
          slidesToScroll            : 1
        };
        this.dataValues = slider.dataset;
        this.slider = slider;
        this.items = this.slider.querySelectorAll('.slider__item').length;
        this.navigationContainer = this.slider.querySelector('.slider__navigation');
        this.dotCount = 0;

        if (this.navigationContainer) {
          this.slider.addEventListener('before.lory.init', () => {
            this.navigationVisibility()
          });

          this.slider.addEventListener('on.lory.resize', () => {
            this.lorySlider.slideTo(0);
            this.navigationVisibility();
          });
        }

        Object.keys(this.dataValues).map((objectKey) => {
          if (objectKey !== 'slidesToScroll') {
            if (!isNaN(parseInt(this.dataValues[objectKey]))) {
              this.config[objectKey] = parseInt(this.dataValues[objectKey]);
            }
            else {
              this.config[objectKey] = this.dataValues[objectKey];
            }
          }
        });

        this.lorySlider = loryLib.lory(this.slider, this.config);
      }

      navigationVisibility() {
        this.itemsNumber();
          const navigationHidden = 'slider__navigation--hidden';

        if (this.itemsLeft >= 1) {
          this.navigationContainer.classList.remove(navigationHidden);
        }
        else {
          this.navigationContainer.classList.add(navigationHidden);
        }
      }

      itemsNumber() {
        const sliderWidth      = this.slider.querySelector('.slider__slides').offsetWidth,
              itemWidth        = this.slider.querySelector('.slider__item').offsetWidth,
              visibleElements  = Math.round(sliderWidth / itemWidth),
              hiddenElements   = (this.items - visibleElements) + 1;

        this.itemsLeft = (hiddenElements > 1) ? (this.items - visibleElements) + 1 : 0;

        return this.itemsLeft;
      }
    }

    new Slider(element);
  }
});
